import React from 'react';
import { Link, useParams } from 'react-router-dom';
import projects from "./../db.json";

function TechPills({ techs }) {
  if (!techs?.[0]) return null;
  const entries = Object.entries(techs[0]).filter(([,v])=> v);
  return (
    <div className="tech-row" style={{marginTop:'10px'}}>
      {entries.map(([k, v])=> (
        <span key={k} className="tech-pill">
          {v && typeof v === 'string' && v.endsWith('.svg') ? <img src={v} alt={k} /> : null}
          {k}
        </span>
      ))}
    </div>
  )
}

export default function Project() {
    const { id } = useParams();
    const project = projects.find(p => String(p.id) === String(id));

    if (!project) {
      return (
        <div className="detail-wrap">
          <Link to="/projects" className="back-link">← Back to projects</Link>
          <div style={{background:'white', border:'1px solid #e2e8f0', borderRadius:'16px', padding:'24px', textAlign:'center'}}>
            <h2>Project not found</h2>
            <p style={{color:'#64748b'}}>No project with ID {id}.</p>
            <Link to="/projects" className="btn btn-primary" style={{marginTop:'12px'}}>Browse all</Link>
          </div>
        </div>
      )
    }

    return (
        <div className='detail-wrap'>
            <Link to="/projects" className="back-link">← Back to projects</Link>

            <div className="detail-hero">
                {project.projectMainImg && (
                  <div className="detail-hero-media">
                    <img src={project.projectMainImg} alt={project.projectName} />
                  </div>
                )}
                <div className="detail-hero-body">
                    <h1 className="detail-title">{project.projectName}</h1>
                    <TechPills techs={project.techs} />
                    {project.projectDescription && <p className="detail-meta">{project.projectDescription}</p>}
                    {project.client && <p style={{marginTop:'8px', fontSize:'0.88rem'}}><strong style={{color:'#0f172a'}}>Client:</strong> {project.client}</p>}
                    {project.job && <p style={{fontSize:'0.85rem', color:'#64748b'}}>Associated with <a href={project.job} target="_blank" rel="noreferrer" style={{color:'#0f172a', fontWeight:700, textDecoration:'underline'}}>{project.job}</a></p>}

                    <div className="detail-actions">
                        {project.projectWebsite && <a href={project.projectWebsite} target="_blank" rel="noreferrer" className="primary">🌐 Live demo</a>}
                        {project.projectGitHubFrontend && <a href={project.projectGitHubFrontend} target="_blank" rel="noreferrer">💻 Frontend</a>}
                        {project.projectGitHubBackend && <a href={project.projectGitHubBackend} target="_blank" rel="noreferrer">⚙️ Backend</a>}
                        {project.projectDesktopApp && <a href={project.projectDesktopApp} target="_blank" rel="noreferrer">🖥️ Desktop</a>}
                        {project.projectMobileApp && <a href={project.projectMobileApp} target="_blank" rel="noreferrer">📱 Mobile</a>}
                    </div>

                    {/* Legacy link dump for edge cases */}
                    <div style={{marginTop:'12px', display:'grid', gap:'6px', fontSize:'0.82rem', color:'#64748b'}}>
                      {project.projectWebsite && <span>Website: <a href={project.projectWebsite} target="_blank" rel="noreferrer" style={{wordBreak:'break-all', color:'#0f172a'}}>{project.projectWebsite}</a></span>}
                      {project.projectGitHubFrontend && <span>GitHub FE: <a href={project.projectGitHubFrontend} target="_blank" rel="noreferrer" style={{wordBreak:'break-all', color:'#0f172a'}}>{project.projectGitHubFrontend}</a></span>}
                      {project.projectGitHubBackend && <span>GitHub BE: <a href={project.projectGitHubBackend} target="_blank" rel="noreferrer" style={{wordBreak:'break-all', color:'#0f172a'}}>{project.projectGitHubBackend}</a></span>}
                    </div>
                </div>
            </div>

            {project.images?.length > 0 && (
              <div className="detail-gallery">
                {project.images.map((image, k) => (
                    <div className="gallery-card" key={k}>
                        {image.imgDescription && <p>{image.imgDescription}</p>}
                        {image.img && <img src={image.img} alt={`${project.projectName} ${k+1}`} loading="lazy" />}
                    </div>
                ))}
              </div>
            )}

            <div style={{display:'flex', gap:'10px', marginTop:'18px', flexWrap:'wrap'}}>
              <Link to="/projects" className="btn btn-ghost">← All projects</Link>
              <Link to="/contact" className="btn btn-primary">Work with me →</Link>
            </div>
        </div>
    )
}
